
import layer from "@/components/layer"
import resetPassword from "@/components/resetPassword"
import { update_password as userSetpwd } from "@/api/file";
export default {
    components: {
        layer,
        resetPassword
    },
    data(){
        return{
            layerObj: {
                show: false,
                title: "重置密码",
                showButtons: false,
                fullscreen: false,
                trueLabel: "确认",
                falseLabel: "取消",
              },
              resetFormData:{},
        }
    },
    methods: {
      closeDialog(){
        this.resetFormData.userPassword=""
        this.resetFormData.confirmPassword=""
      },
        callback(e){
            let that = this;
            this.resetFormData = Object.assign(this.resetFormData,{
              ...e
            })
            let param = Object.assign(this.resetFormData, {
              newPassword: that.fromatPassword(this.resetFormData.userPassword),
              affirmPassword: this.fromatPassword(this.resetFormData.confirmPassword),
            });
            delete param.userPassword
            userSetpwd(param)
              .then((res) => {
                this.$message.success("密码重置成功,请重新登录");
                this.layerObj.show = false
                this.passWord = ""
                this.code = ""

              })
              .catch((err) => {
      
              });
         },
         fromatPassword(val){
            let encrypt_rsa = new this.$jsEncrypt();
            let rsaPublicKey =
              "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJav6tZkpUA-QzSu_dzmchItMfxboS1wIm-Rf8QAUGX80h5fBnyFfMhrvqqoo0V9gsNNgdcJn95Iy5V94BatUNMCAwEAAQ";
            encrypt_rsa.setPublicKey(rsaPublicKey);
      
            return encrypt_rsa.encrypt(val)
          },
    }
  }